import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M65.3 17.347H0.299999V33.347H65.3V17.347Z" fill="white" />
    <path d="M65.3 34.3H0.299999V50.4H65.3V34.3Z" fill="#D80027" />
    <path d="M65.3 0.399994H0.299999V16.4H65.3V0.399994Z" fill="#D80027" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
